import { render, staticRenderFns } from "./DecastDetails.vue?vue&type=template&id=971985d2&scoped=true&"
import script from "./DecastDetails.vue?vue&type=script&lang=js&"
export * from "./DecastDetails.vue?vue&type=script&lang=js&"
import style0 from "./DecastDetails.vue?vue&type=style&index=0&id=971985d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971985d2",
  null
  
)

export default component.exports